module.exports = __webpack_public_path__ + "media/images/gallery/home_on-0fb81fba6c69306e8baabe9672cc2d56.gif";